import { createTypedHooks } from 'easy-peasy'
import { model } from '../state'

const typedHooks = createTypedHooks<typeof model>()

export const useStore = typedHooks.useStore
export const useStoreState = typedHooks.useStoreState
export const useStoreActions = typedHooks.useStoreActions
